import { all, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { PlaylistUser, UserSong } from '../../../services/playlist';
import { fetchWrapperFunc } from '../../../utils';
import { getPlaylistApi, getPlaylistUserApi, getSystemConfig } from '../../System/systemConfig';
import {
    myPlaylistLoad,
    myPlaylistSet,
    MY_PLAYLIST_LOAD,
    MY_PLAYLIST_VOTE,
    MY_PLAYLIST_DELETE_SONG,
    MY_PLAYLIST_UPDATE_VISIBILITY,
    myPlaylistSetVisibility
} from './actions';

function* loadMyPlaylistGenerator() {
    yield* fetchWrapperFunc(() => getPlaylistApi().getMyFavoriteSongs(), [
        (r: UserSong[]) => myPlaylistSet(r)
    ]);
    yield* fetchWrapperFunc(() => getPlaylistUserApi().isPlaylistPublic(), [
        (r: PlaylistUser) => myPlaylistSetVisibility(r.playlistDataPublic)
    ]);
}

function* voteMyPlaylistGenerator(action: Action<{ songId: string; vote: number }>) {
    yield* fetchWrapperFunc(() =>
        getPlaylistApi().vote(action.payload.songId, action.payload.vote )
    );
    yield put(myPlaylistLoad());
}

function* deleteMyPlaylistGenerator(action: Action<string>) {
    yield* fetchWrapperFunc(() => getPlaylistApi().removeUserSong(action.payload ));
    yield put(myPlaylistLoad());
}

function* updateVisibilityGenerator(action: Action<boolean>) {
    yield* fetchWrapperFunc(() =>
        getPlaylistUserApi().updateUserPlaylistPublic(
            getSystemConfig().clientName,
            action.payload
        )
    );
    yield put(myPlaylistLoad());
}

function* watchMyPlaylist() {
    yield takeLatest(MY_PLAYLIST_LOAD, loadMyPlaylistGenerator);
    yield takeEvery(MY_PLAYLIST_VOTE, voteMyPlaylistGenerator);
    yield takeEvery(MY_PLAYLIST_DELETE_SONG, deleteMyPlaylistGenerator);
    yield takeEvery(MY_PLAYLIST_UPDATE_VISIBILITY, updateVisibilityGenerator);
}

export function* myPlaylistSagas() {
    yield all([watchMyPlaylist()]);
}
